import script from "./TokenSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenSelect.vue?vue&type=script&lang=ts&setup=true"

import "./TokenSelect.vue?vue&type=style&index=0&id=7e475d44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e475d44"]])

export default __exports__